import { FocusEvent } from 'react';
import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import { SeparatorVM } from '../../common/ContainerWithSideBar/ContainerWithSideBarVM';
import { DynamicAlignmentProfileStore } from 'cd-eft/models/Stores/DynamicProfile/Alignment/DynamicAlignmentProfileStore';
import { DynamicAlignmentTableStore } from 'cd-eft/models/Stores/DynamicProfile/Alignment/DynamicAlignmentTableStore';
import { EngineeringMapService } from 'cd-eft/framework/mapServices/EngineeringMapServices';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { getListOfDesignElements } from 'cd-eft/components/Design/common/ElementContainer/ElementContainerVM';
import {
  checkDuplicates,
  checkCountForSave,
  deleteSingleAlignmentStationHandler,
  applyDefaultCurvesHandler,
  applyCurvesToAlignment,
  updateCurvesHandler,
  setAlignmentStationToDelete,
  createAlignmentAOI,
  addDesignElementJsonForAlignment,
} from '../../alignment/IndependentAlignment/IndependentAlignmentVM';
import { TerraceDesignToolsController } from 'cd-eft/services/eftSetApi';
import {HydroControllerApi} from 'cd-eft/services/eftEfh2Api';
import {TerraceReachController, HydroController} from 'cd-eft/services/eftSetApi';
import { Efh2InputParamsDeciSSReq } from 'cd-eft/_codegen_/openapi-generator/eft-efh2';
import { terrraceVertexParamsOnDesign } from '../TerraceTemplate/TerraceTemplateVM';
import { DynamicAlignmentMapStore } from 'cd-eft/models/Stores/DynamicProfile/Alignment/DynamicAlignmentMapStore';
import Point from '@arcgis/core/geometry/Point';
import { TerraceUiState } from 'cd-eft/models/Stores/TerraceDesignStore';
import { removeSingleAlignmentLayer } from '../../alignment/AlignmentSummaryTable/AlignmentSummaryTableVM';
import { AppConstants } from 'cd-eft/appConstants';

const { terraceDesignStore, designStore, surveyEngineeringStore, alignmentDesignStore, projectsLibraryStore } = stores.AppStore;

export class TerraceDesignAlignmentViewVM extends SeparatorVM {
  protected profileStoreRef?: DynamicAlignmentProfileStore;
  protected tableStoreRef?: DynamicAlignmentTableStore;
  history;
  @observable props;
  currentObject;

   constructor(props) {
    super(props);
    this.history = props.history;
     designStore.commonHorizontalStretchFactor = undefined;
     designStore.commonVerticalStretchFactor = undefined;

    this.currentObject = alignmentDesignStore.alignmentObject;
    alignmentDesignStore.alignmentObject.editingStatus = 'update';
    this.currentObject.surfaceDefId = designStore.currentSurface.surfaceDefId;
    this.currentObject.surfaceDefTitle = designStore.currentSurface.surfaceDefTitle;
    this.currentObject.sessionId = designStore.projectsStore.currentSessionId;

    if (props.profileStoreRef) {
      this.profileStoreRef = props.profileStoreRef;
    }
    if (props.tableStoreRef) {
      this.tableStoreRef = props.tableStoreRef;
      this.tableStoreRef!.setStore = surveyEngineeringStore;
    }
  }

  @observable formValidation = {
    formErrors: {
      alignmentName: '',
      watershedArea: "",
      peakFlow: "",
    },
    alignmentNameValid: false,
    watershedArea: false,
    peakFlow: false,
    runoffQ: false,
    hasError: false,
    formValid: true,
  };

  @observable disableHydroTool: boolean = false;

  @action.bound applyDefaultCurves = (e?: any) => {
    if (e) e.preventDefault();
    applyDefaultCurvesHandler(this.tableStoreRef, this.currentObject, true);
    this.userLeavingWarningIsShown = true;
  };

  @action.bound deleteStation(e?: any) {
    if (e) e.preventDefault();
    this.disableHydroTool = true;
    this.profileStoreRef!.toggleSecondaryLayersVisibility(false)
    this.tableStoreRef!.deleteStationFromMapClick(setAlignmentStationToDelete);
    this.userLeavingWarningIsShown = true;
  }
  
  @action.bound updateCurves = (e?: any) => {
    updateCurvesHandler(this.tableStoreRef, this.currentObject, true, e);
    this.userLeavingWarningIsShown = true;
  };

  @observable redirectToProfile: boolean = false;
  @observable majorAlignmentChange: boolean = false;
  @observable minorAlignmentChange: boolean = false;

  @action.bound async closeTerraceAlignment() {
  if (this.userLeavingWarningIsShown){
    MessageCenter.addWarning(terraceDesignStore.notifications.unsavedEditsClosePage, [
      {
        callback: () => {
          MessageCenter.clearMessages();
        },
        text: 'Cancel',
      },
      {
        callback: async () => {
          MessageCenter.clearMessages();
          alignmentDesignStore.alignmentObject = { ...this.initialAlignmentObject };
          this.tableStoreRef?.LoadAlignmentToMap(alignmentDesignStore.alignmentObject);
          this.userLeavingWarningIsShown = false;
          this.redirectToProfile = true;
        },
        text: 'OK',
      },
    ], 'Common_13');
    } else {
          this.redirectToProfile = true;
    }
  }

  @observable activeTab: string = 'combined-view';
  @observable showHydroToolModal: boolean = false;
  @observable loading: boolean = false;
 
  @observable.deep curretRunoffValue  = {
    watershedArea: 0,
    watershedCN: 0,
    watershedLength: 0,
    watershedSlope: 0,
    peakFlow: 0,
    runoffQ: 0,
  }
 @observable.deep inputForms = {
  watershedArea: 0,
  watershedCN: 0,
  watershedLength:0,
  watershedSlope:0,
  peakFlow:0,
  runoffQ: 0,
  }
  @action.bound setTab = (selectedTab) => {
    if (this.activeTab !== selectedTab) this.activeTab = selectedTab;
  };

  profileViewActions = {
    'Generate Reaches (non-MVP)': { action: void 0 },
    'Shift Waterway Elevation': { action: () => {} },
    'Set Fixed Width': { action: () => {} },
    'Reset Fixed Widths': { action: () => {}, disabled: true },
    'Set Fixed Depth': { action: () => {} },
    'Reset Fixed Depths': { action: () => {}, disabled: true },
  };

  @action.bound setProfileViewActions() {
    return {
      ...this.profileViewActions,
    };
  }

  @action.bound handleRowMouseEnter(station) {
    const stationX = designStore.commonHorizontalStretchFactor ? station.stationDistance * designStore.commonHorizontalStretchFactor : station.stationDistance;
    const profilePoint = new Point({
        x: stationX,
      y: station.z * (designStore.commonVerticalStretchFactor || AppConstants.profileStretchFactor),
        spatialReference: this.profileStoreRef?._profileView?.spatialReference
    })
    this.profileStoreRef?.trackProfilePoint(profilePoint,`id_${station.stationName}`);

    const mapPoint = new Point({
      x: station.x,
      y: station.y,
      z: station.z,
      spatialReference: projectsLibraryStore.projectSpatialReference
    })
    if (this.profileStoreRef?.hub.MapStore) {
      (this.profileStoreRef?.hub.MapStore as DynamicAlignmentMapStore).trackMapPoint(mapPoint, `id_${station.stationName}`);
    }
  }

  @action.bound handleRowMouseLeave(station) {
    this.profileStoreRef?.unTrackProfilePoint(`id_${station.stationName}`);
    if (this.profileStoreRef?.hub.MapStore) {
      (this.profileStoreRef?.hub.MapStore as DynamicAlignmentMapStore).unTrackMapPoint(`id_${station.stationName}`);
    }
  }

  // *************************************update AlignmentStations in Store
  @action.bound updateSingleAlignmentStation(e: any) {
    const value = e.target.value;
    const name = e.target.name;
    const index = e.target.getAttribute('data-i');

    if (name === 'x' || name === 'y') {
      if (Object.keys(designStore.originalStation).length === 0) {
        designStore.originalStation = Object.assign({}, alignmentDesignStore.alignmentObject.alignmentStations[index]);
      }
      const isNumber = Number(value);
      if (!isNaN(isNumber)) {
        alignmentDesignStore.alignmentObject.alignmentStations[index][name] = +value;
        alignmentDesignStore.updateCurveSave = false;
      }
    } else {
      alignmentDesignStore.alignmentObject.alignmentStations[index][name] = +value;
      if ((name as string).toLowerCase() === 'curvevalue') {
        this.tableStoreRef!.onCurveValueChanged(parseInt(index), parseFloat(value));
      }
      alignmentDesignStore.updateCurveSave = false;
    }
    alignmentDesignStore.disableSaveAlignment = false;
    this.userLeavingWarningIsShown = true;
  }

  @action.bound updateMapAndProfile(e: any) {
    const index = e.target.getAttribute('data-i');
    this.tableStoreRef!.updateAlignment(this.tableStoreRef!.currentObject, index);
  }

  handleCurveValueInputFocus = (e: FocusEvent<HTMLInputElement>, index: number) => {
    const curveValue = e.target.value;
    this.tableStoreRef!.focusStationIndex = index;
    if (0 < index && index < alignmentDesignStore.alignmentObject.alignmentStations.length - 1) {
      this.tableStoreRef!.onCurveValueChanged(index, parseFloat(curveValue));
      EngineeringMapService?.instance?.unTrackLast();
      // console.log(alignmentDesignStore.alignmentObject.alignmentStations[index]);
      alignmentDesignStore.alignmentObject.alignmentStations[index].curveType = 2;
    }
  };

  @action.bound async generateProfiles() {
    await this.getData();
    await this.profileStoreRef?.generateTerraceProfile(2, 5, terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId, true); // Use default sample and vertical intervals
    await this.profileStoreRef?.createReachFromSavedDesign(terraceDesignStore.terraceDesignObject.terraceDesignStations, terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId);
    if (this.profileStoreRef?.checkSecondaryLayerStatus()) await this.profileStoreRef?.drawTerraceStructures();
  }

  protected async handleMouseUpResizeActions(currentViewExtent) {
    if (this.profileStoreRef?._profileView && currentViewExtent) {
      this.profileStoreRef._profileView.extent = currentViewExtent;
      await this.profileStoreRef.redrawMappingProfiles();
      await this.profileStoreRef.createReachFromSavedDesign(terraceDesignStore.terraceDesignObject.terraceDesignStations, terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId);
    }
  }
  @observable isPeakFlowManuallyEdited: boolean = false;
  @action.bound handleInputsOnChange(event) {
    const { name, value } = event.target;
    this.inputForms[name] = value;
    if (name === 'watershedArea') {
      this.calculationPerformed = false;
      if (Number(this.inputForms.peakFlow) !== Number(this.curretRunoffValue.peakFlow)) {
        this.isPeakFlowManuallyEdited = true;
      } else {
        this.isPeakFlowManuallyEdited = false;
      }
    } else if (name === 'peakFlow') {
      this.isPeakFlowManuallyEdited = true;
    }
    this.userLeavingWarningIsShown = true;
  }
  @action.bound hydroToolErrorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage?.length === 0 ? '' : ' usa-input--error';
  }
  @action.bound handleOnKeyDown(event) {
    ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
  }
  @action.bound onCancel(){
    this.showHydroToolModal = false;
    this.formValidation.formErrors.watershedArea = "";
    this.formValidation.formErrors.peakFlow = "";
    MessageCenter.resetMessageCenter()
  }

  @action.bound async validateInput(name: string, value) {
    const isValid = !isNaN(value) && value !== '' && value > 0;  
    switch (name) {
      case 'watershedArea':
      case 'peakFlow':
        this.formValidation[name] = !isValid;
        this.formValidation.formErrors[name] = isValid ? '' : ' ';
        this.formValidation.hasError = !isValid;
  
        if (!isValid) {    
          await MessageCenter.addNotificationFromCode('Common_10',undefined, name ==='watershedArea'? "Drainage Area" : "Peak Flow Q");
        }
        break;
    }
  }
  @action.bound async loadInputDataFromStore() {
    this.loading = true; 
    try {
        this.curretRunoffValue = this.inputForms = {
          peakFlow: terraceDesignStore.hydroInputValues.peakFlow ?? 0,
          runoffQ: terraceDesignStore.hydroInputValues.runoffQ ?? 0,
          watershedArea: terraceDesignStore.hydroInputValues.watershedArea ?? 0,
          watershedCN: terraceDesignStore.hydroInputValues.watershedCN ?? 0,
          watershedLength: terraceDesignStore.hydroInputValues.watershedLength ?? 0,
          watershedSlope:terraceDesignStore.hydroInputValues.watershedSlope ?? 0
        }; 
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound moveStation(e: any) {
    e.preventDefault();
    this.disableHydroTool = true
    this.profileStoreRef!.toggleSecondaryLayersVisibility(false)
    if (this.currentObject.alignmentApplyCurves === "true") {
      this.tableStoreRef!.moveStation(this.updateCurves);
    } else {
      this.tableStoreRef!.moveStation();
    }
    this.userLeavingWarningIsShown = true;
  }

  @action.bound async insertStation(e: any) {
    MessageCenter.clearMessages()
    e.preventDefault();
    this.disableHydroTool = true;
    this.profileStoreRef!.toggleSecondaryLayersVisibility(false)
    if (this.currentObject.alignmentStations.length < 2) {
      await MessageCenter.addErrorFromCode('Alignment_21'); // You must create an alignment before inserting a station.
      return false;
    }
    if (this.currentObject.alignmentApplyCurves === "true") {
      this.tableStoreRef!.insertStation(this.applyDefaultCurves);
    } else {
      this.tableStoreRef!.insertStation();
    }
    this.userLeavingWarningIsShown = true;
  }

  @action.bound async saveTerraceAlignment(e: any) {
    e.preventDefault();
    const curves = this.currentObject.alignmentStations.filter((station) => {
      return station.curveValue > 0;
    });
    if (curves.length > 0 && !alignmentDesignStore.updateCurveSave) {
      await MessageCenter.addErrorFromCode('Alignment_23');
    } else {
      alignmentDesignStore.updateCurveSave = true;
      this.tableStoreRef?.clearDeleteStation();
      //alignmentStore.removeAlignmentLabelsLayer(EngineeringMapService.instance?.mapView);
      designStore.isLoading = true;
      this.tableStoreRef?.completeMapSketch();
      const noDuplicates = await checkDuplicates(this.currentObject);
      const countIsValid = await checkCountForSave(this.currentObject);
      // const noClosedLoop = await this.checkSelfClosed();
      // const noSelfCrossed = await this.checkSelfCrossed();
      // const checkNameDuplicateResult = await checkNameDuplicate(this.currentObject, this.formValidation);
      if (noDuplicates && countIsValid && this.formValidation.formValid) {

        /* Start * validate the Alignment edit is major or minor */
        if (this.disableHydroTool){
        const payload_testAlignmentEdit = {
          "alignedElementDesignParamsId": terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId, 
          "alignmentStationList": this.currentObject.alignmentStations
        }
        await this.checkAlignmentEdit(payload_testAlignmentEdit)
        /* End * validate the Alignment edit is major or minor */
      }
        if(!this.majorAlignmentChange){
          await this.saveAlignmentEdits();
          // save ui state --- minor change or no changes
          await terraceDesignStore.handleUiStateUpdate({uiStateType: TerraceUiState.ChannelDesignSave.string});

       }
      }
    }
    alignmentDesignStore.begginingStation = '0';
    designStore.isLoading = false;
    alignmentDesignStore.disableSaveAlignment = true;
    this.userLeavingWarningIsShown = false;
  }

  async saveAlignmentEdits() {
    // reset the Z values if the user drawing 2D alignment
    if (projectsLibraryStore.resetZValue) {
      this.currentObject.alignmentStations = this.currentObject.alignmentStations.map((station) => ({
        ...station,
        z: 0,
      }));
    }
    // save alignment
    this.currentObject.editingStatus = 'update';
    const postJSON = { ...this.currentObject };
    const validApplyCurvesToAlignment = await applyCurvesToAlignment(this.tableStoreRef, postJSON, true);
    if (validApplyCurvesToAlignment) {
      if (alignmentDesignStore.unsavedAlignments.has(postJSON.designElementId)) postJSON.designElementId = 0;
      if (postJSON.alignmentXY) delete postJSON.alignmentXY;
      if (postJSON.curvedAlignmentXY) delete postJSON.curvedAlignmentXY;
      await addDesignElementJsonForAlignment(postJSON, true);

      const payload_adjustReachStationNames = {
        "alignedElementId": terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId,
        "alignmentDTO": postJSON
      }
      try {
        //adjust reach name based on alignment edits
        await TerraceReachController.adjustReachStationNamesUsingPOST(payload_adjustReachStationNames);
      } catch (error) {
        MessageCenter.addError((error as Error).message);
      }

      // generate AOI
      const data = this.currentObject.alignmentStations;
      await createAlignmentAOI(data);

      // ************ Temporary for PI 28 Happy Path. If user saves alignment, they must redraw the channel. Proper handling to come in PI 29.
      this.profileStoreRef?.resetSecondaryLayers();
      terraceDesignStore.constructedProfileStations = [];
      terraceDesignStore.waterLevelData = [];
      terraceDesignStore.settledProfileStations = [];
      // ************
    }
  }

  @action.bound async checkAlignmentEdit(payload) {
    this.majorAlignmentChange = false;
    const response: any = await TerraceDesignToolsController.testAlignmentEditUsingPOST(payload)
    if (response && response.data && response.data.errorResponse) {
      await MessageCenter.addNotificationFromCode(response.data.errorResponse.errorCode);
    }
    else if (response && response.data && !response.data.errorResponse) {
      if (response.data.offsetCode === 1) {
        await MessageCenter.addInfoFromCode('Terrace_16');
        this.minorAlignmentChange = true;
        this.disableHydroTool = false;
      } else if(response.data.offsetCode === 2) {
        await this.majorAlignmentEditInfoModal();
        this.majorAlignmentChange = true;
      }
    }
   }

  @observable majorAlignmentEditMessage
  @action.bound async majorAlignmentEditInfoModal(): Promise<void>{
    return new Promise<void>( async (resolve) => {
      this.majorAlignmentChange = true;
      this.majorAlignmentEditMessage = await MessageCenter.getMessageFromCode('Terrace_18');
      resolve();
    });
  }

  @action.bound async handleCancelMajorAlignmentEdit(){
    await this.generateProfiles()    
    this.majorAlignmentChange = false;
    this.disableHydroTool = false;
    MessageCenter.resetMessageCenter()
  }

  @action.bound async handleMajorAlignmentEdit(e) {
    this.loading = true;
    this.majorAlignmentChange = false;
    await this.saveAlignmentEdits();
    this.tableStoreRef?.cleanUpMap();
    terraceDesignStore.terraceDesignObject.terraceDesignStations = [];
    designStore.alignmentProfileStations = [];
    this.profileStoreRef?.removeSketch();
    try {
      await TerraceReachController.deleteAllTerraceReachWithAlignedElementDesignParametersIdUsingPOST(terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId);
      // save ui state
      await terraceDesignStore.handleUiStateUpdate({uiStateType: TerraceUiState.TerraceInputSave.string});
      this.history.push(`/design/${designStore.projectsStore.currentProject.projectUuid}/terrace/${terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId}/input`)
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    }
    this.loading = false;
  }

  @observable initialAlignmentObject: any;
  @action.bound getData = async () => {
    const alignmentDesignElementJsonId = terraceDesignStore.alignmentDesignElementJsonId.toString();
    removeSingleAlignmentLayer(`alignment${alignmentDesignElementJsonId}`);
    const result: any = await getListOfDesignElements(alignmentDesignElementJsonId);
    if (result && result[0]) {
      const itemData = result[0];
      const jsonData = JSON.parse(itemData.json!);
      const alignmentData = {
        ...jsonData,
        designElementId: itemData.designElementId,
        designElementName: itemData.designElementName,
        designElementTypeId: itemData.designElementTypeId,
        sessionId: itemData.sessionId,
        //sessionUuid: itemData.sessionId,
        surfaceDefId: designStore.currentSurface.surfaceDefId,
      };
      // fixing stationName for alignment duplicates
      alignmentData.alignmentStations.forEach((el) => {
        el.stationName = el.stationName ? Number(el.stationName) : Math.round(el.stationDistance);
        el.z = Number(el.z) ? Number(el.z) : 0;
      });
      alignmentDesignStore.alignmentObject = {
        ...alignmentDesignStore.alignmentObject,
        ...alignmentData,
      };
      this.initialAlignmentObject = { ...alignmentDesignStore.alignmentObject };
      alignmentDesignStore.begginingStation = alignmentDesignStore.alignmentObject.beginningStationDis.toString();
      this.currentObject = alignmentDesignStore.alignmentObject;
      this.currentObject.surfaceDefId = designStore.currentSurface.surfaceDefId;
      this.currentObject.surfaceDefTitle = designStore.currentSurface.surfaceDefTitle;
      this.currentObject.sessionId = designStore.projectsStore.currentSessionId;
      this.tableStoreRef!.alignmentStore = alignmentDesignStore;
      this.tableStoreRef!.CurrentObject = this.currentObject;
    }
  };

  @observable latlongInfo: string = '';
  @observable rainfallCellID: number = 0;
  @action.bound async openHydroTool() {
    try {
      designStore.isLoading = true;
      const response = await TerraceDesignToolsController.getBasinCharacteristicsDtoByAlignedElementIdUsingGET(terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId);
      
      if (response?.data) {
        this.calculationPerformed = false;
        this.isPeakFlowManuallyEdited = false;
        this.latlongInfo = response.data.latLongInfo ?? "";
        this.rainfallCellID = 840807;
        this.curretRunoffValue = this.inputForms = {
          peakFlow: response.data.peakFlow ?? 0,
          watershedArea: response.data.watershedArea ?? 0,
          watershedCN: response.data.watershedCN ?? 0,
          watershedLength: response.data.watershedLength ?? 0,
          watershedSlope: response.data.watershedSlope ?? 0,
          runoffQ: response.data.runoffQ ?? 0,
        };
      }
      this.showHydroToolModal = true;
    } catch (error) {
      console.error(error);
      await MessageCenter.addErrorFromCode('HYDRO_01');
    } finally {
      designStore.isLoading = false;
    }
  }
  
  @action.bound async calculateHydro() {
    try {
      designStore.isLoading = true;
      
      const requestPayload: Efh2InputParamsDeciSSReq = {
        client: designStore.projectsStore.currentProject.client,
        state: designStore.projectsStore.currentProject.state,
        county: designStore.projectsStore.currentProject.county,
        latlonInfo: this.latlongInfo,
        practice: designStore.projectsStore.currentProject.practice,
        user: designStore.projectsStore.currentProject.createdBy,
        createDate: designStore.projectsStore.currentProject.createdDate,
        drainageArea: Number(this.inputForms.watershedArea),
        timeC: 0.101,
        runoffCN: this.curretRunoffValue.watershedCN,
        watershedLen: this.curretRunoffValue.watershedLength,
        watershedSlope: this.curretRunoffValue.watershedSlope,
        dimUnitHydrog: "Standard-484",
        dimUnitHydrogID: 0,
        rainfallCellID: this.rainfallCellID,
        stormFrequency: "10 year",
        rdt_smoothing: "true",
        projectUuid: designStore.projectsStore.currentProject.projectUuid,
        demServiceSelected: "",
        demServiceMetadataUrl: "",
        note: "",
        metadata: ""
      };
  
      const calcResponse = await HydroControllerApi.generateWinTR20ResultsSiteSpecificSubBasinUsingPOST(requestPayload);
  
      if (calcResponse?.data) {
        this.inputForms = {
          ...this.inputForms,
          peakFlow: calcResponse.data.peakFlow ?? 0,
          runoffQ: calcResponse.data.runoffQ ?? 0
        };
        this.calculationPerformed = true;
      }
    } catch (error) {
      console.error(error);
      await MessageCenter.addErrorFromCode('HYDRO_01');
    } finally {
      designStore.isLoading = false;
    }
  }
  @observable calculationPerformed: boolean = false;
  @action.bound async saveHydro() {
    this.minorAlignmentChange = false;
    try {
      designStore.isLoading = true;
      const requestPayload = {
        alignedElementId: terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId,
        drainageArea: Number(this.inputForms.watershedArea),
        peakFlow: Number(this.inputForms.peakFlow),
        runoffQ: Number(this.inputForms.runoffQ)
      };
      const response = await HydroController.updateSubBasinUsingPOST(requestPayload);
      if (response && response.data && response.data.errorResponse) {
        await MessageCenter.addNotificationFromCode(response.data.errorResponse.errorCode!);
      } else if (response && response.data && !response.data.errorResponse) {
        await TerraceDesignToolsController.terraceSimulationAndValidationUsingGET(terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId);
        this.showHydroToolModal = false;
      }
    } catch (error) {
      console.error(error);
      await MessageCenter.addErrorFromCode('HYDRO_01');
    } finally {
      designStore.isLoading = false;
    }
  }

  // *************************************************************** user leaving
  @observable userLeavingWarningIsShown: boolean = false;
  @action.bound userLeavingWarningOnOk = () => {
    // this.userLeavingWarningIsShown = !this.userLeavingWarningIsShown;
    this.userLeavingWarningIsShown = true;
  };

  // *************************************************************** delete station
  @action.bound deleteSingleAlignmentStation = () => {
    deleteSingleAlignmentStationHandler(this.tableStoreRef, this.currentObject, true);
  };

  @action.bound removeAlignmentSketch = () => {
    if (this.profileStoreRef?.hub.MapStore) {
      (this.profileStoreRef?.hub.MapStore as DynamicAlignmentMapStore).removeAlignmentGraphic();
    }
  };

  @action.bound init = async () => {
    await terrraceVertexParamsOnDesign();
  };
}
